import axios from "axios";
import cookie from "react-cookies";
import { getCacheBostVal, getToken, isJSON, isUBN } from "../js/Util";
import { ConVar } from "../js/ConfigVar";
import config from "../commonComponent/config";

export const httpGetRequest1 = (url, callback, tobePassed) => {
  let headers = {
    "Content-Type": "application/x-www-form-urlencoded",
  };
  let noofRetries = 0;
  axios
    .get(url, {
      headers,
      "axios-retry": {
        retries: noofRetries ? noofRetries : 0,
      },
    })
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      console.log(error);
      console.log("error");
    });
};

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const httpGetRequest = (url, callback, noofRetries) => {  
  if (
    url.includes("login") ||
    url.includes("setPassword") ||
    url.includes("uauth/forgotpassword") ||
    url.includes("updatePassword")
  ) {
    url = (url.includes("?")
            ? url + "&proxypass=true"
            : url + "?proxypass=true");
  }
  url = url.includes("?") ? url + "&" + getCacheBostVal() : url + "?" + getCacheBostVal();
  var retries = 1;                    
  callAjaxData();

  function callAjaxData() {
      var xhr = new XMLHttpRequest();
      xhr.ontimeout = function () {
        console.error("The request for " + url + " timed out.");
      };
      xhr.open("GET", url, true);
      if (!isUBN(cookie.load("token"))) {
        let token = cookie.load("token");
        xhr.setRequestHeader("CliAuth", token);
      } 
      if (cookie.load("login")) {
        let r1 = cookie.load(ConVar.authCookieName);
        let userName = r1 ? r1.email : "";
        let dept = r1 ? r1.dept : "";
        xhr.setRequestHeader("User-Email", userName);
        xhr.setRequestHeader("Department", dept);
        xhr.setRequestHeader("Content-cookie", JSON.stringify(r1));
      }
      xhr.onload = function() {
          if (xhr.status === 200 && xhr.readyState === 4) {
              let resData = {};
              try {
                  if (isJSON(xhr.response)) {
                    resData.data = JSON.parse(xhr.response);
                  } else {
                    resData.data = xhr.response;
                  }
              } catch (e) {
                  console.log(e);
              }
              callback(resData);
          } else if (xhr.status === 401) {
              // retry
              if (retries--) {          
                getToken(function(){
                  callAjaxData();
                });  
              } else {
                  // *** Out of retries
                  callback(xhr.response);
              }
          } else {
              let response = {};
              try {
                  response = xhr.response;
                  callback(response);
              } catch (e) {
                callback(xhr.response);
              }
          }
      };
      xhr.send(null);
  }
};

export const httpGetRequestDispatch = (url, callback, noofRetries) => {  
  if (
    url.includes("login") ||
    url.includes("setPassword") ||
    url.includes("uauth/forgotpassword") ||
    url.includes("updatePassword")
  ) {
    url = (url.includes("?")
            ? url + "&proxypass=true"
            : url + "?proxypass=true");
  }
  url = url.includes("?") ? url + "&" + getCacheBostVal() : url + "?" + getCacheBostVal();
  var retries = 1;                    
  callAjaxData();

  function callAjaxData() {
      var xhr = new XMLHttpRequest();
      xhr.ontimeout = function () {
        console.error("The request for " + url + " timed out.");
      };
      xhr.open("GET", url, true);
      if (!isUBN(cookie.load("token"))) {
        let token = cookie.load("token");
        xhr.setRequestHeader("CliAuth", token);
      } 
      if (cookie.load("login")) {
        let r1 = cookie.load(ConVar.authCookieName);
        let userName = r1 ? r1.email : "";
        xhr.setRequestHeader("User-Email", userName);
        xhr.setRequestHeader("Content-cookie", JSON.stringify(r1));
      }
      xhr.onload = function() {
          if (xhr.status === 200 && xhr.readyState === 4) {
              let resData = {};
              try {
                  if (isJSON(xhr.response)) {
                    resData.data = JSON.parse(xhr.response);
                  } else {
                    resData.data = xhr.response;
                  }
              } catch (e) {
                  console.log(e);
              }
              callback(resData);
          } else if (xhr.status === 401) {
              // retry
              if (retries--) {          
                getToken(function(){
                  callAjaxData();
                });  
              } else {
                  // *** Out of retries
                  callback(xhr.response);
              }
          } else {
              let response = {};
              try {
                  response = xhr.response;
                  callback(response);
              } catch (e) {
                callback(xhr.response);
              }
          }
      };
      xhr.send(null);
  }
};

export const httpGetRequestWithAuth = (url, callback, noofRetries) => {  
  if (
    url.includes("login") ||
    url.includes("setPassword") ||
    url.includes("uauth/forgotpassword") ||
    url.includes("updatePassword")
  ) {
    url = (url.includes("?")
            ? url + "&proxypass=true"
            : url + "?proxypass=true");
  }
  url = url.includes("?") ? url + "&" + getCacheBostVal() : url + "?" + getCacheBostVal();
  var retries = 1;                    
  callAjaxData();

  function callAjaxData() {
      var xhr = new XMLHttpRequest();
      xhr.ontimeout = function () {
        console.error("The request for " + url + " timed out.");
      };
      xhr.open("GET", url, true);
      if (!isUBN(cookie.load("token"))) {
        let token = cookie.load("token");
        xhr.setRequestHeader("CliAuth", token);
      } 
      if (cookie.load("login")) {
        let r1 = cookie.load(ConVar.authCookieName);
        let userName = r1 ? r1.email : "";
        let dept = r1 ? r1.department_id : "";
        xhr.setRequestHeader("User-Email", userName);
        xhr.setRequestHeader("Department", dept);
        xhr.setRequestHeader("Content-cookie", JSON.stringify(r1));
        xhr.setRequestHeader("Authorization", 'Basic ' +
            btoa(
              config.username +
              ':' +
              config.password,
            )
          );
      }
      xhr.onload = function() {
          if (xhr.status === 200 && xhr.readyState === 4) {
              let resData = {};
              try {
                  if (isJSON(xhr.response)) {
                    resData.data = JSON.parse(xhr.response);
                  } else {
                    resData.data = xhr.response;
                  }
              } catch (e) {
                  console.log(e);
              }
              callback(resData);
          } else if (xhr.status === 401) {
              // retry
              if (retries--) {          
                getToken(function(){
                  callAjaxData();
                });  
              } else {
                  // *** Out of retries
                  callback(xhr.response);
              }
          } else {
              let response = {};
              try {
                  response = xhr.response;
                  callback(response);
              } catch (e) {
                callback(xhr.response);
              }
          }
      };
      xhr.send(null);
  }
};

export const httpPutRequestNw = (url, callback, noofRetries) => {
  if (
    url.includes("login") ||
    url.includes("setPassword") ||
    url.includes("uauth/forgotpassword") ||
    url.includes("updatePassword")
  ) {
    url = (url.includes("?")
            ? url + "&proxypass=true"
            : url + "?proxypass=true");
  }
  var retries = 1;
  callAjaxData();
  function callAjaxData() {
    var xhr = new XMLHttpRequest();
    xhr.ontimeout = function () {
      console.error("The request for " + url + " timed out.");
    };
    xhr.open("PUT", url, true); //false is sync

    if (!isUBN(cookie.load("token"))) {
      let token = cookie.load("token");
      xhr.setRequestHeader("CliAuth", token);
    } 
    if (cookie.load("login")) {
      let r1 = cookie.load(ConVar.authCookieName);
      let userName = r1 ? r1.email : "";
      xhr.setRequestHeader("User-Email", userName);
      xhr.setRequestHeader("Content-cookie", JSON.stringify(r1));
    }
    xhr.onload = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let resData = {};
          try {
            if (isJSON(xhr.response)) {
              resData.data = JSON.parse(xhr.response);
            } else {
              resData.data = xhr.response;
            }
          } catch (err) {
            console.log(err);
          }
          callback(resData);
        } else if (xhr.status === 401) {
          // retry
          if (retries--) {          
            getToken(function(){
              callAjaxData();
            });  
          } else {
              // *** Out of retries
              callback(xhr.response);
          }
        } else {
          callback(xhr.response);
          // console.error(xhr.statusText);
        }
      }
    };
    xhr.send(null);
  }
};
export const httpDeleteRequest = (url, callback, noofRetries) => {
  if (
    url.includes("login") ||
    url.includes("setPassword") ||
    url.includes("uauth/forgotpassword") ||
    url.includes("updatePassword")
  ) {
    url = (url.includes("?")
            ? url + "&proxypass=true"
            : url + "?proxypass=true");
  }
  var retries = 1;                    
  callAjaxData();
  function callAjaxData() {
    var xhr = new XMLHttpRequest();
    xhr.ontimeout = function () {
      console.error("The request for " + url + " timed out.");
    };    
    xhr.open("DELETE", url, true); //false is sync

    if (!isUBN(cookie.load("token"))) {
      let token = cookie.load("token");
      xhr.setRequestHeader("CliAuth", token);
    } 
    if (cookie.load("login")) {
      let r1 = cookie.load(ConVar.authCookieName);
      let userName = r1 ? r1.email : "";
      let dept = r1 ? r1.department_id : "";
      xhr.setRequestHeader("User-Email", userName);
      xhr.setRequestHeader("Department", dept);
      xhr.setRequestHeader("Content-cookie", JSON.stringify(r1));
    }
    xhr.onload = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let resData = {};

          try {
            if (isJSON(xhr.response)) {
              resData.data = JSON.parse(xhr.response);
            } else {
              resData.data = xhr.response;
            }
          } catch (err) {
            console.log(err);
          }
          callback(resData);
        }  else if (xhr.status === 401) {
          // retry
          if (retries--) {          
            getToken(function(){
              callAjaxData();
            });  
          } else {
              // *** Out of retries
              callback(xhr.response);
          }
        } else {
          callback(xhr.response);
          // console.error(xhr.statusText);
        }
      }
    };
    xhr.send(null);
  }
};
export const httpPutRequest = (url, dataObj, callback, cType) => {
  var retries = 1;
    let r1 = {},
      headers = {},
      userName = "",
      token = "";

    if (
      url.includes("login") ||
      url.includes("setPassword") ||
      url.includes("forgotpassword") ||
      url.includes("updatePassword")
    ) {
      headers = {
        "Content-Type": cType ? cType : "application/x-www-form-urlencoded",
      };
    } else {
      token = cookie.load("token");
      r1 = getCookie(ConVar.authCookieName) ? JSON.parse(getCookie(ConVar.authCookieName)) : {};
      userName = r1.email;
      headers = {
        "Content-Type": cType ? cType : "application/x-www-form-urlencoded",
        "User-Email": userName,
        "Content-cookie": JSON.stringify(r1),
        "CliAuth": token
      };
    }

  callAjaxData();
  function callAjaxData() {
    axios
      .put(url, dataObj, { headers,
        "axios-retry": {
          retries: retries ? retries : 0,
        } })
      .then(function (response) {
        callback(response);
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {

          // Retry the request if it's a 401 error and we haven't reached the maximum number of retries
          if (retries--) {
                      
            getToken(function(){
            callAjaxData(); // Retry the request
            });
          } else {
            // Max retries reached, handle the error
            callback("error", error);
          }
        } else {
          // Handle other errors
          callback("error", error);
        }
      });
  }
};
export const httpPostReqReg = (url, dataObj, callback, cType) => {
  var retries = 1;  
  let r1 = {},
    headers = {},
    userName = "",
    dept = "",
    token = "";
  if (
    url.includes("login") ||
    url.includes("setPassword") ||
    url.includes("uauth/forgotpassword") ||
    url.includes("updatePassword") ||
    url.includes("captchaV3Verify")||
    url.includes("validate/token")
  ) {
    url = !url.includes("s3upload")
        ? (url.includes("?")
            ? url + "&proxypass=true"
            : url + "?proxypass=true")
        : (url);
    headers = {
      "Content-Type": cType ? cType : "application/x-www-form-urlencoded",
    };
    if(dataObj.token){
      headers["sso-login"] = dataObj.ssoLogin;
      headers["Authorization"] = `Bearer ${dataObj.token}`;
    }
  } else {
    token = cookie.load("token");
    r1 = getCookie(ConVar.authCookieName) ? JSON.parse(getCookie(ConVar.authCookieName)) : {};
    userName = r1.email;
    dept = r1 ? r1.department_id : "";
    headers = {
      "Content-Type": cType ? cType : "application/x-www-form-urlencoded",
      "User-Email": userName,
      "Department": dept,
      "Content-cookie": JSON.stringify(r1),
      "CliAuth": token
    };
  }
                    
  callAjaxData();
  function callAjaxData() {
    axios.post(url, dataObj, { headers })
      .then(function (response) {
        callback(response);
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          // Retry the request if it's a 401 error and we haven't reached the maximum number of retries
          if (retries--) {                     
            getToken(function(){
            callAjaxData(); // Retry the request
            });
          } else {
            // Max retries reached, handle the error
            callback("error", error);
          }
        } else {
          // Handle other errors
          callback("error", error);
        }
      });
  }
};

